import ComposePage from './components/ComposePage'

export default ComposePage
